import { useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { cacheCurrentUser, getUserStoreData } from "store/slices";
import External from "../components/layout/External";
import { userApi } from "service/api";
import { useCancelableDebouncedApi } from "hooks";

const OnboardRoute = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { callApi } = useCancelableDebouncedApi();
  const { is_onboarding_complete, pendingScreen, campuses, id } =
    useSelector(getUserStoreData);
  let location = useLocation();

  useEffect(() => {
    if (!is_onboarding_complete && location.pathname === "/onboarding") {
      switch (pendingScreen) {
        case "districts":
          navigate("create_district", { replace: true });
          break;
        case "invite_admin":
          navigate("invite_admin");
          break;
        case "saml_auth":
          navigate("saml_auth");
          break;
        case "campuses":
          navigate("create_campus");
          break;
        // case "building":
        //   navigate("create_building");
        //   break;
        case "complete":
          navigate("complete");
          break;
        default:
          navigate("create_district");
          break;
      }
    }
  }, [is_onboarding_complete, location.pathname, navigate, pendingScreen]);

  useEffect( () => {
    const onbardingComplete = async () => {
      await callApi(async () => {
        const res = await userApi.update(id, {
          is_onboarding_complete: true,
        });
        if (!res.error) {
          dispatch(cacheCurrentUser({ ...res.data }));
        }
        return res;
      });
    };
    // not on the campus step (its save already finishes onboarding and opens
    // the complete page) nor on the complete page (Let's Go finishes it)
    if (
      !is_onboarding_complete &&
      campuses?.length > 0 &&
      location.pathname !== "/onboarding/complete" &&
      location.pathname !== "/onboarding/create_campus"
    ) {
      onbardingComplete();
    }
  }, [is_onboarding_complete, campuses, id, location.pathname, callApi, dispatch]);

  if (is_onboarding_complete) {
    return <Navigate to="/home" replace />;
  }

  return <External />;
};

export default OnboardRoute;